import React, { useContext, useEffect, useState } from 'react';
import { ReportSkusModalContext } from './ReportSkusModal';
import { post } from '../../../../shared/components/ApiRequest';

const EnterSkus = ({skus}) => {
    const { setStep, setTitles, setSongs, setCount, setMissing, setSkus } = useContext(ReportSkusModalContext);

    const handleSubmit = async (e) => {
        const res = await post(urlCheckSku, { skus }, $(e.target));

        if (!res.isError) {
            setTitles(res.titles);
            setSongs(res.songs);
            setCount(res.count);
            setMissing(res.missing);
            setStep(2);
        } else {
            toastr.error(res.msgError);
        }
    }

    return (
        <div className="row fade in">
            <div className="col-lg-12">
                <p className="text-center">Enter list of SKU numbers, one per row</p>
            </div>
            <div className="col-lg-12">
                <form>
                    <div className="form-group">
                        <textarea name="skus" rows="10" className="form-control" style={{ resize: 'vertical' }} value={skus} onChange={e => setSkus(e.target.value)}></textarea>
                    </div>
                </form>
            </div>
            <div className="col-lg-6 col-lg-offset-3">
                <button type="button" className="btn btn-block btn-purple" onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};

export default EnterSkus;